import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import MText from '../MText';

function CheckBox({ checked, onChange, style, text, textSize, disabled }) {
  return (
    <div className="d-flex flex-row align-items-center">
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={style}
        disabled={disabled}
      />
      <MText text={text} size={textSize} />
    </div>
  );
}

CheckBox.defaultProps = {
  checked:  false,
  disabled: false,
  onChange: () => {},
  style:    {},
  text:     '',
  textSize: 12,
};

CheckBox.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  checked:  PropTypes.bool,
  style:    PropTypes.shape(Object),
  text:     PropTypes.string,
  textSize: PropTypes.number,
};

export default CheckBox;
